<div class="printable-nav-tab">
	<div
		class="printable-nav-button"
		*ngFor="let product of printableButtonItems; let i = index"
		[ngClass]="{ active: currentProduct == product?.widgetPath }"
	>
		<app-printable-report-r1></app-printable-report-r1>
	</div>
</div>
